import { Process } from 'types/process';
import baseApi, { API_V1 } from './base';
import { DocumentData } from 'types/document';
import { BatchStatusListTypes, BathcFileDetailsTypes, PredictionBatchDetailsType, ReviewDocumentStatusType } from 'types/prediction';

const predictionApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPredictionProcesses: build.query<Process[], void>({
      query: () => ({
        url: `${API_V1}/Prediction/GetPredictionProcessDetails`,
        params: {}
      })
    }),
    getPredictionDocumentTypes: build.query<DocumentData[], { processId: number; batchtypeid?: any }>({
      query: ({ processId, batchtypeid = 1 }) => ({
        url: `${API_V1}/Prediction/GetPredictionDocumentType`,
        params: { processId, batchtypeid: batchtypeid }
      }),
      transformResponse: (responseData: { data: DocumentData[] }) => responseData.data || []
    }),
    getPredictionBatchList: build.query<PredictionBatchDetailsType[], { docTypeID: number }>({
      query: ({ docTypeID }) => ({
        url: `${API_V1}/Prediction/GetPredictionBatchDetail`,
        params: { DocumentTypeId: docTypeID }
      }),
      transformResponse: (responseData: { data: PredictionBatchDetailsType[] }) =>
        responseData.data
          ? responseData.data.map((row) => ({ ...row, batchStatus: String(row.batchStatus).replace(' ', '').toUpperCase() }))
          : []
    }),
    getPredictionFileList: build.query<
      BathcFileDetailsTypes[],
      {
        batchID: number;
        screenType?: 'Prediction' | 'Assurance' | 'Verification';
        batchTypeID?: any;
        shouldRemoveVerified?: boolean;
      }
    >({
      query: ({ batchID, screenType = 'Prediction', batchTypeID = 1 }) => ({
        url: `${API_V1}/Prediction/GetPredictionFileDetail`,
        params: { BatchID: batchID, ScreenType: screenType, batchTypeID: batchTypeID }
      }),

      transformResponse: (responseData: { data: { fileList: BathcFileDetailsTypes[] } }, _meta, arg) => {
        let data = (responseData?.data?.fileList || []).map((file) => ({
          ...file,
          statusName: String(file.statusName).replaceAll(' ', '').toUpperCase(),
          parentBatchID: String(arg.batchID),

          ...(arg.screenType !== 'Assurance' && { batchID: String(arg.batchID) })
        }));

        if (arg.shouldRemoveVerified) {
          data = data.filter(({ statusName }) => statusName !== ReviewDocumentStatusType.QCVERIFIED);
        }
        return data;
      }
    }),
    predictionBatchStartReprocess: build.mutation<any, { batchID: string }>({
      query: ({ batchID }) => ({
        url: `${API_V1}/Prediction/UpdateBatchReProcess`,
        params: { BatchID: batchID },
        method: 'POST'
      })
    }),
    getPredictionBatchStatusList: build.query<BatchStatusListTypes[], void>({
      query: () => ({
        url: `${API_V1}/Prediction/GetBatchStatusDetail`
      }),
      transformResponse: (responseData: { data?: BatchStatusListTypes[] }) => responseData?.data || []
    })
  })
});

export const {
  useGetPredictionProcessesQuery,
  useGetPredictionDocumentTypesQuery,
  useGetPredictionBatchListQuery,
  useGetPredictionFileListQuery,
  useLazyGetPredictionFileListQuery,
  usePredictionBatchStartReprocessMutation,
  useLazyGetPredictionBatchStatusListQuery,
  useLazyGetPredictionBatchListQuery
} = predictionApi;

export default predictionApi;
